import { useEffect, useState } from 'react';
import {
  readRecordDiscussionPlacement,
  RECORD_DISCUSSION_PLACEMENT_CHANGED_EVENT,
  type RecordDiscussionPlacement
} from './recordDiscussionPrefs';

export function useRecordDiscussionPlacement(): RecordDiscussionPlacement {
  const [placement, setPlacement] = useState<RecordDiscussionPlacement>(() =>
    readRecordDiscussionPlacement()
  );

  useEffect(() => {
    const sync = () => setPlacement(readRecordDiscussionPlacement());
    window.addEventListener(RECORD_DISCUSSION_PLACEMENT_CHANGED_EVENT, sync);
    return () => window.removeEventListener(RECORD_DISCUSSION_PLACEMENT_CHANGED_EVENT, sync);
  }, []);

  return placement;
}
